import { render, staticRenderFns } from "./phone-login.vue?vue&type=template&id=76047772&scoped=true"
import script from "./phone-login.vue?vue&type=script&lang=js"
export * from "./phone-login.vue?vue&type=script&lang=js"
import style0 from "./phone-login.vue?vue&type=style&index=0&id=76047772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76047772",
  null
  
)

export default component.exports